import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { api, timeline } from './util';

/**
 * /events: a timeline of upcoming (or past) events, filtered by place or online. Moderators also see what is
 * waiting for approval, with Approve and Turn down; members see their own waiting events.
 */
export default class EventsList extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.data = null;
    this.past = null;
    this.when = 'upcoming';
    this.filter = 'all';
    // /events?place=uk: one place's events (a country's include its cities'), from a tag page's Useful links
    const place = String(m.route.param('place') || '');
    this.place = /^[a-z0-9-]{1,100}$/.test(place) ? place : null;
    this.load();
  }
  placeQuery() {
    return this.place ? '&place=' + encodeURIComponent(this.place) : '';
  }
  placeName() {
    if (this.data && this.data.place) return this.data.place.name;
    const tag = (app.store.all('tags') || []).find(t => t.slug() === this.place);
    return tag ? tag.name() : this.place;
  }
  clearPlace() {
    this.place = null;
    this.data = null;
    this.past = null;
    this.when = 'upcoming';
    this.filter = 'all';
    m.route.set('/events');
    this.load();
  }
  load() {
    app.request({
      method: 'GET',
      url: api() + '?limit=100' + this.placeQuery(),
      errorHandler: () => {}
    }).then(r => this.data = r || {
      events: []
    }).catch(() => this.data = {
      events: []
    }).then(() => m.redraw());
  }
  showPast() {
    this.when = 'past';
    this.filter = 'all';
    if (this.past) return;
    app.request({
      method: 'GET',
      url: api() + '?when=past&limit=50' + this.placeQuery(),
      errorHandler: () => {}
    }).then(r => this.past = r && r.events || []).catch(() => this.past = []).then(() => m.redraw());
  }
  review(e, status) {
    e.busy = true;
    app.request({
      method: 'POST',
      url: api('/' + e.id),
      body: {
        status
      }
    }).then(() => {
      app.alerts.show({
        type: 'success'
      }, status === 'approved' ? 'Event approved: it is live now.' : 'Event turned down.');
      this.load();
    }).catch(() => e.busy = false);
  }
  newEvent() {
    if (!app.session.user) {
      const b = document.querySelector('.item-signUp .Button, .item-signUp button');
      if (b) b.click();
      return;
    }
    m.route.set('/events/new');
  }
  view() {
    if (!this.data) return m(LoadingIndicator, null);
    const upcoming = this.data.events || [];
    const list = this.when === 'past' ? this.past : upcoming;
    if (list === null) return m(LoadingIndicator, null);
    // filters: everything, online, then each place that has events (most first)
    const counts = {};
    list.forEach(e => {
      if (!e.placeSlug) return;
      counts[e.placeSlug] = counts[e.placeSlug] || {
        name: e.placeName,
        n: 0,
        slug: e.placeSlug
      };
      counts[e.placeSlug].n += 1;
    });
    const places = Object.values(counts).sort((a, b) => b.n - a.n).slice(0, 10);
    const online = list.filter(e => e.format !== 'in_person').length;
    const shown = this.filter === 'all' ? list : this.filter === 'online' ? list.filter(e => e.format !== 'in_person') : list.filter(e => e.placeSlug === this.filter);
    const chip = (key, label, n) => m("button", {
      type: "button",
      className: 'VouchaJoin-chip' + (this.filter === key ? ' is-on' : ''),
      onclick: () => this.filter = key
    }, label, n ? m("small", null, n) : null);
    return m("div", {
      className: "VEvt"
    }, m("div", {
      className: "VEvt-top"
    }, m("div", {
      className: "VEvt-switch",
      role: "tablist"
    }, m("button", {
      type: "button",
      role: "tab",
      "aria-selected": this.when === 'upcoming' ? 'true' : 'false',
      className: this.when === 'upcoming' ? 'is-on' : '',
      onclick: () => (this.when = 'upcoming', this.filter = 'all')
    }, "Upcoming"), m("button", {
      type: "button",
      role: "tab",
      "aria-selected": this.when === 'past' ? 'true' : 'false',
      className: this.when === 'past' ? 'is-on' : '',
      onclick: () => this.showPast()
    }, "Past")), m(Button, {
      className: "Button Button--primary VEvt-create",
      icon: "fas fa-plus",
      onclick: () => this.newEvent()
    }, "Create event")), this.data.pending && this.data.pending.length && this.when === 'upcoming' ? m("section", {
      className: "VEvt-box VEvt-pending"
    }, m("h3", null, "Waiting for approval (", this.data.pending.length, ")"), timeline(this.data.pending, e => m("span", {
      className: "VEvt-actions",
      onclick: ev => (ev.preventDefault(), ev.stopPropagation())
    }, m(Button, {
      className: "Button Button--primary",
      loading: e.busy,
      onclick: () => this.review(e, 'approved')
    }, "Approve"), m(Button, {
      className: "Button",
      disabled: e.busy,
      onclick: () => this.review(e, 'rejected')
    }, "Turn down")))) : null, this.data.mine && this.data.mine.length && this.when === 'upcoming' ? m("section", {
      className: "VEvt-box"
    }, m("h3", null, "Your events"), timeline(this.data.mine, e => m("span", {
      className: 'VEvt-status is-' + e.status
    }, e.status === 'pending' ? 'Waiting for approval' : 'Not approved'))) : null, this.place ? m("div", {
      className: "VEvt-placeBar"
    }, m("span", null, m("i", {
      className: "fas fa-location-dot",
      "aria-hidden": "true"
    }), " Events in ", m("b", null, this.placeName())), m("button", {
      type: "button",
      className: "VEvt-placeClear",
      onclick: () => this.clearPlace()
    }, "All events ", m("i", {
      className: "fas fa-xmark",
      "aria-hidden": "true"
    }))) : null, list.length ? m("div", {
      className: "VouchaJoin-chips VEvt-filters",
      role: "group",
      "aria-label": "Filter events"
    }, chip('all', 'All', list.length), online ? chip('online', 'Online', online) : null, places.map(p => chip(p.slug, p.name, p.n))) : null, shown.length ? timeline(shown) : this.when === 'past' ? m("div", {
      className: "VEvt-empty"
    }, m("p", null, "No past events", this.place ? ' in ' + this.placeName() : '', " yet.")) : m("div", {
      className: "VEvt-empty"
    }, m("i", {
      className: "far fa-calendar",
      "aria-hidden": "true"
    }), m("h3", null, "No upcoming events", this.place ? ' in ' + this.placeName() : ''), m("p", null, "Running a meetup, a talk or a get-together", this.place ? ' in ' + this.placeName() : '', "? Create it here and people near you will see it."), m(Button, {
      className: "Button Button--primary",
      onclick: () => this.newEvent()
    }, "Create event")));
  }
}
flarum.reg.add('voucha-community', 'forum/events/EventsList', EventsList);